import { useEffect } from 'react';
import Router from 'next/router';
import { useBeforeUnload } from 'react-use';

export const useLeavePageConfirm = (
  isConfirm = true,
  message = '入力内容は保持されません。画面を離れますか？'
) => {
  useBeforeUnload(isConfirm, message);

  useEffect(() => {
    const handler = () => {
      // eslint-disable-next-line
      if (isConfirm && !window.confirm(message)) {
        throw 'Route Canceled';
      }
    };

    Router.events.on('routeChangeStart', handler);

    return () => {
      Router.events.off('routeChangeStart', handler);
    };
  }, [isConfirm, message]);
};
